import type { Product } from './types'

/* Live product registry. Populated by InventoryProvider from the GraphQL API.
   Pages/components look products up synchronously via these helpers, while the
   reactive copy is also exposed through useInventory().products. */
export let products: Product[] = []
export let productCategories: string[] = []

export function setProducts(next: Product[]): void {
  products = next
  productCategories = Array.from(
    new Set(next.map((p) => p.category).filter(Boolean)),
  ).sort()
}

export const productById = (id: string) => products.find((p) => p.id === id)
export const productBySku = (sku: string) => products.find((p) => p.sku === sku)
